import request from '@/api/request'

export function login (username, password, recaptcha) {
  return request({
    url: '/login',
    method: 'post',
    data: {
      username,
      password,
      recaptcha
    }
  })
}

export function logout () {
  return request({
    url: '/logout',
    method: 'post'
  })
}

export function googLogin () {
  return request({
    url: '/goog-login',
    method: 'get'
  })
}

export function googAuth (query) {
  return request({
    url: '/goog-auth',
    method: 'get',
    params: query
  })
}

export function mfaVerify (token) {
  return request({
    url: '/login/mfa',
    method: 'post',
    data: {
      token
    }
  })
}
